
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class InstagramIconOverlay extends Vue {}
